import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { MoreIcon } from "@/shared/assets/icons";
import { Button, Dropdown, DropdownItem } from "@/shared/ui";

interface Props {
  draftId: number;
  onDeleteDraft: (id: number) => void;
  direction?: "top" | "bottom";
}

export default function DraftActionsDropdown({ draftId, onDeleteDraft, direction = "bottom" }: Props) {
  const { t } = useTranslation("EmployeesPage");
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown open={isOpen} onClose={() => setIsOpen(false)} width="w-max" direction={direction} align="right">
      <Button
        variant="secondary"
        isIconButton
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className="w-8! radius-xs! p-0!">
        <MoreIcon />
      </Button>
      <DropdownItem
        onClick={() => {
          navigate(`/hr/import-worker?draftId=${draftId}`);
          setIsOpen(false);
        }}>
        {t("draft.editAction")}
      </DropdownItem>
      <DropdownItem
        className="content-action-negative"
        onClick={() => {
          onDeleteDraft(draftId);
          setIsOpen(false);
        }}>
        {t("draft.deleteAction")}
      </DropdownItem>
    </Dropdown>
  );
}
